import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { DELETE_SERVICE_WORTH, DELETE_SERVICE_WORTH_SUCCESS, DELETE_SERVICE_WORTH_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* deleteServiceWorth({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/service-worth`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        objectId: payload?.objectId,
      },
      data: payload,
    });

    if (response.status === 200) {
      cogoToast.success(`Deleted successfully`);
      yield put({
        type: DELETE_SERVICE_WORTH_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DELETE_SERVICE_WORTH_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DELETE_SERVICE_WORTH_ERROR, payload: error });
  }
}

export function* watchDeleteServiceWorth() {
  yield takeEvery(DELETE_SERVICE_WORTH, deleteServiceWorth);
}

function* deleteServiceWorthSaga() {
  yield all([fork(watchDeleteServiceWorth)]);
}

export default deleteServiceWorthSaga;
